import {
    CompanyAttributes,
    DocumentClassAttributes,
    DocumentRangeAttributes,
    MaterialAttributes,
    MaterialStockAttributes,
    OrderAttributes,
    OrderDetailAttributes,
    OrderDetailMaterialAttributes,
    OrderDetailUnitOfMeasureAttributes,
    OrderExtraStatusAttributes,
    TripAttributes,
    WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    createComponent,
    EnvironmentInjector,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {
    MatPaginatorIntl,
    MatPaginatorModule,
    PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
    MatSidenav,
    MatSidenavContainer,
    MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
    IPaginationResult,
    IPaginationResultFrequencies,
    IRequestResult,
} from "app/common/interfaces";
import { SelectionModel } from "@angular/cdk/collections";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import { MatMenuModule } from "@angular/material/menu";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
    debounceTime,
    distinctUntilChanged,
    lastValueFrom,
    Observable,
} from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { getCode } from "app/utils/method";
import { Router } from "@angular/router";
import { environment } from "environments/environment.prod";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import {
    ExportFileFormat,
    ExportRange,
} from "app/layout/export-overlay/tasks/core/export-task.enum";
import { CompanyService } from "../../configuration/company/company.service.service";
import { MasterUserInterface } from "../../sales/order-generate/interfaces/master-user.interface";
import { OrdersCreationService } from "../../sales/order-generate/order-generate.service";
import { UpdateOrderService } from "../../sales/update-order/update-order.service";
import { OrdersListService } from "../../sales/order-list-components/order-list.service";
import { MatTabsModule } from "@angular/material/tabs";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { validateOrdersByAction } from "app/utils/document-class-validation";
import { MaterialService } from "../../material/material/material.service";
import { ModalTransportComponent } from "./modal-transport/modal-transport.component";
import { GuiaRemisionComponent } from "./pdf-transport/pdf-transport.component";
import { DomSanitizer } from "@angular/platform-browser";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { PdfService } from "./pdf-transport/pdf-transport.service";
import { DocumentRangeService } from "../../document/document-range/document-range.service";
import { TripRouteService } from "../../sales/trip/trip.service";
import { ViewDeliveriesComponent } from "./view-deliveries/view-deliveries.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { DocumentNavigationComponent } from "app/common/components/document-navigation/document-navigation.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";

@Component({
    selector: "app-transport-load-list",
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatDialogModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSortModule,
        MatPaginatorModule,
        MatIconModule,
        MatTabsModule,
        MatSlideToggle,
        MatSelectModule,
        MatOptionModule,
        MatTooltipModule,
        MatExpansionModule,
        MatSidenav,
        MatSidenavContainer,
        MatCheckboxModule,
        MatMenuModule,
        GuiaRemisionComponent,
        NgSelectModule,
        MatDatepickerModule,
        FormsModule,
        MonedaPipe,
        MatProgressSpinnerModule,
        DecimalFormatPipe,
        DocumentNavigationComponent,
        UnitMeasureDisplayComponent
    ],
    providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
    templateUrl: "./transport-load-list.component.html",
    styleUrl: "./transport-load-list.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger("detailExpand", [
            state("collapsed,void", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition(
                "expanded <=> collapsed",
                animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
            ),
        ]),
    ],
})
export class TransportLoadListComponent implements OnInit {
    OrderStatusERPEnum = OrderStatusERPEnum
    
    @ViewChild("unifiedModal") unifiedModal!: TemplateRef<any>;

    @Input() summaryData: OrderAttributes[] | null = null;
    @Input() UMPActive: boolean = false;
    @Input() isAllColumns: boolean = true;
    @Input() isSearch: boolean = false;
    @Output() refreshMonitor = new EventEmitter();
    @Input() trip: TripAttributes | null = null;;

    @Input() totalItems: number = 0;
    @Input() pageSize: number = 10;
    @Input() currentPage: number = 1;

    @Output() pageChanged = new EventEmitter<PageEvent>();

    getCode = getCode;
    projectName = environment.projectName;

    displayedColumns: string[] = [
        "det",
        // "check",
        "status",
        "type",
        "view",
        // "statusERP",
        "doc",
        "documentNumber",
        "class",
        'nro',
        "creation",
        "actions",
    ];

    paymentMethodsDataSource = new MatTableDataSource<any>([]);

    dataSource = new MatTableDataSource<OrderAttributes>([]);
    totalItemsIn: number = 0;
    searchControl = new FormControl("");
    search: string = "";
    pageIndex: number = 1;
    sortActive: keyof OrderAttributes = "createdAt";
    sortDirection: "asc" | "desc" = "desc";

    selection = new SelectionModel<any>(true, []);
    selectedOrder: OrderAttributes | null = null;

    //DETAIL
    displayedColumnsDetail: string[] = [
        "view",
        "material",
        // "note",
        "warehouse",
        "soldQuantity",
        // "unitPrice",
        // "subTotal",
        // "totalSurcharges",
        // "totalDiscounts",
        // "tax",
        // "total",
        // "actions",
    ];
    dataSourceDetail = new MatTableDataSource<OrderDetailAttributes>([]);

    companyList: CompanyAttributes[] = [];

    //Filter
    selectedStartDate: Date;
    selectedEndDate: Date;
    dateRange: FormGroup;
    selectedStatusERP: number = 0;
    selectedDocumentClass: string = "0";
    selectedSeller: string = "0";
    selectedWithTravel: string = "0";

    documentClassesList: DocumentClassAttributes[] = [];
    sellerList: MasterUserInterface[] = [];

    isGlobalSynchronizeAvailable: boolean = false;

    orderStatusErpList = [
        { id: null, name: "Todos" },
        { id: 0, name: "Pendiente" },
        { id: 4, name: "Error enviando a ERP" },
        { id: 1, name: "Enviado a ERP" },
        { id: 2, name: "Recibido por ERP" },
        { id: 3, name: "Creado en ERP" },
    ];

    isOrderListTrip = environment.isOrderListTrip;
    isErpIntegrated = environment.isErpIntegrated;

    @ViewChild("orderDetailUpdateConfirmationDialog") orderDetailUpdateConfirmationDialog!: TemplateRef<any>;
    @ViewChild('guiaRef') guiaComponent!: GuiaRemisionComponent;
    isGeneratingPDF = false; // Estado de carga
    currentProcessingId: string | null = null; // ID del elemento en proceso

    interval;
    timeInterval = 60000 * 15;
    showInterval: boolean = false;
    guiaData: OrderAttributes;
    companies: CompanyAttributes[] = [];

    displayedColumnsHistoric: string[] = ["serial", "soldTo", "shipTo", "quantities"]
    dataSourceHistoric = new MatTableDataSource<any>([]);
    
    documentRangeList: DocumentRangeAttributes[] = [];

    constructor(
        private readonly ordersListService: OrdersListService,
        private readonly salesOfficeService: SalesOfficeService,
        private readonly warehouseService: WarehouseService,
        private readonly documentClassService: DocumentClassService,
        private readonly companyService: CompanyService,
        private readonly snackBar: MatSnackBar,
        private readonly dialog: MatDialog,
        private readonly cdr: ChangeDetectorRef,
        private fb: FormBuilder,
        private exportService: ExportService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private injector: EnvironmentInjector,
        private documentRangeService : DocumentRangeService,
        private tripService: TripRouteService
    ) {
        this.matIconRegistry.addSvgIcon(
            "pdf",
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                "assets/icons/pdf-svgrepo-com.svg"
            )
        );
        const today = new Date();
        this.dateRange = this.fb.group({
            start: [today],
            end: [today],
        });
        this.selectedStartDate = today;
        this.selectedEndDate = today;
        // this.selectedStartDate.setHours(0, 0, 0, 0);
        this.selectedEndDate.setHours(23, 59, 59, 999);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["summaryData"] && this.summaryData) {
            this.dataSource.data = this.summaryData;
            // 3. Obtener clases de documento dinámicamente
            const documentType = this.summaryData[0]?.type?.code;
            if (documentType) {
                this.fetchDocumentClass(documentType);
            }
        }
    }

    ngOnInit(): void {
        if (this.summaryData) {
            this.dataSource.data = this.summaryData;
            this.cdr.detectChanges();
        }
    }


    public onSearchChange(event) {
        const search = (event.target as HTMLInputElement).value
            .trim()
            .toLowerCase();

        this.dataSource.data = this.summaryData.filter((data: any) => {
            return data?.soldTo?.name.toLowerCase().includes(search);
        });
    }

    applyFilter(filterValue: string) {
        this.pageIndex = 1;
        this.search = filterValue;
        this.getList();
    }

    openInterval(event) {
        //para el html si se quiere activar o no
        if (!event) {
            this.showInterval = false;
        } else {
            this.showInterval = true;
        }
        this.onFilter();
    }

    onFilter() {
        if (this.showInterval) {
            if (this.interval) {
                clearInterval(this.interval);
            }
            this.getList();

            this.interval = setInterval(() => {
                this.getList();
            }, this.timeInterval);
        } else {
            this.getList();
        }
    }

    getList() {
        this.synchronizeDates();
        this.isGlobalSynchronizeAvailable = false;
        this.resetSelection();

        const sortField = this.getSortField();
        const sortDirection: "ASC" | "DESC" =
            this.sortDirection === "asc" ? "ASC" : "DESC";

        let options = {
            currentPage: this.pageIndex,
            limitPerPage: this.pageSize,
            search: this.search,
            sort: sortField,
            sortDirection: sortDirection,
        };
        let dataFilter = {
            type: DocumentTypeEnum.DOCUMENTO_DE_CARGA, // Documentos de carga
            startDate: new Date(
                new Date(this.selectedStartDate).setHours(0, 0, 0, 0)
            ).toISOString(),
            endDate: new Date(
                new Date(this.selectedEndDate).setHours(23, 59, 59, 999)
            ).toISOString(),
            documentClass: this.selectedDocumentClass,
            seller: this.selectedSeller.toString(),
            withTravel: this.selectedWithTravel,
            statusERP: this.selectedStatusERP,
        };

        this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
            next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
                this.dataSource.data = res?.data?.data ?? [];
                this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener información de los pedidos.","Cerrar",{ duration: 5000});
            },
        });
    }

    private getSortField(): keyof OrderAttributes {
        const sortFieldMapping: Record<string, keyof OrderAttributes> = {
            status: "statusERP",
            type: "type",
            trip: <any>"trip.id",
            subRoute: <any>"subRoute.name",
            user: <any>"user.user_login.username",
            soldTo: <any>"soldTo.name",
            documentNumber: "serial",
            class: <any>"class.name",
            date: "deliveryDateTime",
            creation: "creationDateTime",
        };
        return sortFieldMapping[this.sortActive] || "creationDateTime";
    }

    changeSort(e) {
        this.sortActive = e.active;
        this.sortDirection = e.direction;
        // this.getList()
    }

    // changePage(e: PageEvent) {
    //   this.pageIndex = e.pageIndex + 1;
    //   this.pageSize = e.pageSize;
    //   this.getList();
    // }

    changePage(event: PageEvent) {
        this.pageChanged.emit(event);
        this.currentPage = event.pageIndex + 1;
        this.pageSize = event.pageSize;
    }

    isAllSelected() {
        const validRows = this.dataSource.data.filter((row) =>
            this.validateDataToSynchronize(row)
        );

        const numSelected = this.selection.selected.length;
        const numValidRows = validRows.length;
        return numSelected == numValidRows && numValidRows > 0;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => {
                if (this.validateDataToSynchronize(row)) this.selection.select(row);
            });
    }

    resetSelection() {
        this.selection.clear();
    }

    checkboxLabel(row?: any): string {
        if (!row) {
            return `${this.isAllSelected() ? "select" : "deselect"} all`;
        }
        return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
    }

    onCheckboxChange(event, element?): void {
        let auxSelected = this.selection.selected;
        this.isGlobalSynchronizeAvailable =
            auxSelected.length > 0 &&
            auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
            0;
    }

    async toggleDetails(order: OrderAttributes): Promise<void> {
        if (this.selectedOrder && this.selectedOrder._id === order._id) {
            this.closeDetails();
            return;
        }

        this.selectedOrder = order;
        this.dataSourceDetail.data = this.selectedOrder.detail || [];
        // Obtiene compañía para hacer uso de flags
        const companyFound: CompanyAttributes = this.companies.find(
            (c) => c.id == this.selectedOrder.company?.id
        );
        if (companyFound) this.selectedOrder.company = companyFound;

        // Obtiene almacenes y clase de documento
        const orderStatusId = this.selectedOrder.statusId;
        if (orderStatusId != StatusEnum.INACTIVE && orderStatusId != StatusEnum.ORDER_APPROVED && orderStatusId != StatusEnum.ORDER_REJECTED) {
            await this.getDocumentClass(this.selectedOrder);

            if (
                this.selectedOrder.class["showCurrentStockForMaterials"] == true &&
                !this.selectedOrder["warehousesToUpdate"]
            ) {
                const salesOffice: Partial<SalesOfficeAttributes> = await lastValueFrom(
                    this.salesOfficeService.findOne(
                        this.selectedOrder.salesOffice._id.toString()
                    )
                ).then((res) => res.data);
                if (salesOffice && salesOffice.warehouses) {
                    let filter = {
                        officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
                        company: [environment.companyId],
                    };
                    this.selectedOrder["warehousesToUpdate"] = await lastValueFrom(
                        this.warehouseService.filterComboBox(filter)
                    ).then((res) => res.data);
                }
            }
        }
    }

    closeDetails(): void {
        this.selectedOrder = null;
    }

    formatDate(date: string | Date, includeTime?: boolean): string {
        if (date) {
            const d = new Date(date);
            const day = d.getDate().toString().padStart(2, "0");
            const month = (d.getMonth() + 1).toString().padStart(2, "0");
            const year = d.getFullYear();

            if (includeTime) {
                const hours = d.getHours().toString().padStart(2, "0");
                const minutes = d.getMinutes().toString().padStart(2, "0");
                const seconds = d.getSeconds().toString().padStart(2, "0");
                return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
            }
            return `${day}-${month}-${year}`;
        }
        return "--:--:--";
    }

    formatHour(date: string): string {
        if (date) {
            const d = new Date(date);
            const hours = d.getHours().toString().padStart(2, "0");
            const minutes = d.getMinutes().toString().padStart(2, "0");
            const seconds = d.getSeconds().toString().padStart(2, "0");
            return `${hours}:${minutes}:${seconds}`;
        }
        return "--:--:--";
    }

    onCompanySelectionChange(companyid: string): void {
        /*if (this.currentUpdateWarehouse) {
          this.currentUpdateWarehouse.company = this.companyList.find(
            (price) => price._id.toString() === companyid
          )!;
        }*/
    }

    clearFilters(): void {
        /*this.selectedCompanyIds = [];
        this.searchQuery = "";
        this.findAllWithCount();*/
        const today = new Date();
        this.dateRange.reset({ start: today, end: today });
        this.selectedStartDate = null;
        this.selectedEndDate = null;
        this.selectedStatusERP = 0;
        this.selectedDocumentClass = "0";
        this.selectedSeller = "0";
    }

    synchronizeDates(): void {
        this.selectedStartDate = this.dateRange.get("start")?.value;
        this.selectedEndDate = this.dateRange.get("end")?.value;
    }

    compareById(item1: any, item2: any): boolean {
        return item1 && item2 ? item1._id === item2._id : item1 === item2;
    }

    async getCompanies(): Promise<void> {
        this.companies = [];
        await lastValueFrom(this.companyService.fetchCompanyByEnvIds())
            .then((res) => {
                this.companies = res.data;
            })
            .catch((err) => {
                this.snackBar.open(err.error.message, "Cerrar", { duration: 3000 });
            });
    }

    private fetchDocumentClass(documentType: string): void {
        let dataToFilter = {
            type: documentType,
        };
        this.ordersListService
            .fetchDocumentClasses(dataToFilter)
            .subscribe((res) => {
                this.documentClassesList = res.data;
            });
    }

    private getListSeller() {
        this.ordersListService.fetchMasterUsers().subscribe({
            next: (res: IRequestResult<MasterUserInterface[]>) => {
                if (res.status == "success") {
                    this.sellerList = res.data;
                }
            },
            error: (err) => {
                this.snackBar.open(err.error.message || "Error al obtener vendedores.","Cerrar",{ duration: 5000});
            },
        });
    }

    synchronizeOrders(order: OrderAttributes) {
        let dataToSendPost = {
            TripIds: [],
            orderIds: [],
            method: "POST",
        };

        let dataToSendPut = {
            TripIds: [],
            orderIds: [],
            method: "PUT",
        };

        // Datos para el servicio (no-DocumentTypeEnum.DOCUMENTO_DE_CARGA)
        let dataToSendOtherPost = {
            TripIds: [],
            orderIds: [],
            method: "POST",
        };

        let dataToSendOtherPut = {
            TripIds: [],
            orderIds: [],
            method: "PUT",
        };

        const isDT003 = (item: OrderAttributes) => {
            return item.type.code === DocumentTypeEnum.DOCUMENTO_DE_CARGA;
        };

        if (order) {
            // Caso 1: Orden individual
            if (isDT003(order)) {
                // Servicio  para DocumentTypeEnum.DOCUMENTO_DE_CARGA
                if (order.externalKeys?.code) {
                    dataToSendPut.orderIds.push(order._id.toString());
                } else {
                    dataToSendPost.orderIds.push(order._id.toString());
                }
            } else {
                // Servicio OTRO para no-DocumentTypeEnum.DOCUMENTO_DE_CARGA
                if (order.externalKeys?.code) {
                    dataToSendOtherPut.orderIds.push(order._id.toString());
                } else {
                    dataToSendOtherPost.orderIds.push(order._id.toString());
                }
            }
        } else {
            // Caso 2: Selección múltiple
            this.selection.selected.forEach((o) => {
                if (isDT003(o)) {
                    // Servicio  para DocumentTypeEnum.DOCUMENTO_DE_CARGA
                    if (o.externalKeys?.code) {
                        dataToSendPut.orderIds.push(o._id.toString());
                    } else {
                        dataToSendPost.orderIds.push(o._id.toString());
                    }
                } else {
                    // Servicio OTRO para no-DocumentTypeEnum.DOCUMENTO_DE_CARGA
                    if (o.externalKeys?.code) {
                        dataToSendOtherPut.orderIds.push(o._id.toString());
                    } else {
                        dataToSendOtherPost.orderIds.push(o._id.toString());
                    }
                }
            });
        }

        const requests = [];

        // Servicio  (DocumentTypeEnum.DOCUMENTO_DE_CARGA)
        if (dataToSendPost.orderIds.length > 0) {
            requests.push(
                this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
            );
        }
        if (dataToSendPut.orderIds.length > 0) {
            requests.push(
                this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
            );
        }

        // Servicio OTRO (no-DocumentTypeEnum.DOCUMENTO_DE_CARGA)
        if (dataToSendOtherPost.orderIds.length > 0) {
            requests.push(
                this.ordersListService
                    .synchronizeOrdersOther(dataToSendOtherPost)
                    .toPromise()
            );
        }
        if (dataToSendOtherPut.orderIds.length > 0) {
            requests.push(
                this.ordersListService
                    .synchronizeOrdersOther(dataToSendOtherPut)
                    .toPromise()
            );
        }

        if(requests.length === 0) {
            this.snackBar.open("No se encontraron registros pendientes de sincronizar con ERP.","Cerrar",{ duration: 5000});
        }

        Promise.all(requests)
            .then(() => {
                this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
                    duration: 3000,
                });
                this.refreshMonitor.emit();
                // this.getList();
            })
            .catch((err) => {
                this.snackBar.open(err.error.message || "Error al sincronizar con el ERP.","Cerrar",{ duration: 5000});
            });
    }


    round(valor: number): number {
        return parseFloat(valor.toFixed(3)) ?? 0;
    }




    async getDocumentClass(order: OrderAttributes) {
        const documentClass: DocumentClassAttributes = await lastValueFrom(
            this.documentClassService.findOne(String(order.class._id))
        ).then((res) => res.data);
        if (documentClass) order.class = documentClass;
        this.cdr.detectChanges();
    }

    roundToX(value: number, decimals: number) {
        return parseFloat(value.toFixed(decimals));
    }

    openLogModal(element) {
        let dataToModal = {
            documentIdentifier: element.serial,
        };

        const dialogRef = this.dialog.open(LogModalComponent, {
            panelClass: ".form-modal-interlocutor",
            width: "90%",
            data: dataToModal,
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
            }
        });
    }

    validateDataToSynchronize(order: OrderAttributes) {
        return validateOrdersByAction([order], this.documentClassesList, "SYNC");
    }


    onExportButtonPressed() {
        const id = "sales-quotation-list";
        if (this.exportService.taskIsActive(id)) {
            this.exportService.setVisible(true);
            return;
        }
        this.exportService
            .createForSalesQuotationList(
                this.totalItems,
                this.ordersListService.currentFilter,
                this.ordersListService.currentFilterData,
                ExportRange.CurrentPage,
                ExportFileFormat.Excel
            )
            .start();

        /* const dialogRef = this.dialog.open(ExportDialogComponent);
        dialogRef.afterClosed().subscribe((options: ExportOptions) => {
          if (options) {
            this.exportService.createForSalesQuotationList(
              this.totalItems,
              this.orderCustomer.currentFilter,
              options.range,
              options.format,
            ).start();
          }
        }); */
    }

    ngOnDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }


    //Documento de Transporte
    openModalTransport(element): void {
        const dialogRef = this.dialog.open(ModalTransportComponent, {
            data: this.trip,
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.refreshMonitor.emit();
        });
    }

    //Ver Entregas
    getDoc(element: OrderAttributes): void {
        const dialogRef = this.dialog.open(ViewDeliveriesComponent, {
            data: element.sourceTransactions,
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    iconConfig = {
        DT009: {
            icon: "heroicons_solid:exclamation-circle",
            iconType: "svg",
            tooltip: "En espera de aprobación",
            color: "rgb(236, 199, 58)",
        },
        DT010: {
            icon: "heroicons_solid:exclamation-circle",
            iconType: "svg",
            tooltip: "En espera de aprobación",
            color: "rgb(236, 199, 58)",
        },
        DT013: {
            icon: "local_shipping",
            iconType: "font",
            tooltip: "En espera de recolección",
            color: "rgb(236, 199, 58)",
        },
        DT012: {
            icon: "swap_vert",
            iconType: "font",
            tooltip: "En espera de cambio de producto",
            color: "rgb(236, 199, 58)",
        },
        default: {
            icon: "heroicons_solid:check-circle",
            iconType: "svg",
            tooltip: "Creado",
            color: "rgb(65, 106, 218)",
        },
    };

    getIconConfig(code: string) {
        return this.iconConfig[code] || this.iconConfig.default;
    }

    getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
        const status = list.find((i) => i.type == type);
        return status?.description || "-";
    }

    annularDocument(order: OrderAttributes) {
        const allTransactionIds = order.detail
            .flatMap(a => a.unifiedSourceTransactions.map(u => u._id.toString()))
            .filter((value, index, self) => self.indexOf(value) === index);

        const requestData = {
            serial: allTransactionIds
        };
        this.ordersListService.annularDocumentTransport(order._id.toString(), requestData).subscribe({
            next: () => {
                this.snackBar.open("Documento anulado con éxito", "Cerrar", {
                    duration: 3000,
                });
                //   this.getList();
            },
            error: (err) => {
                this.snackBar.open(
                    err.error.message || "Error al anular documento",
                    "Cerrar",
                    { duration: 3000 }
                );
            },
        });
    }

    openHistory(order: OrderDetailAttributes): void {
        this.dataSourceHistoric.data = order.unifiedSourceTransactions;
        this.dialog
            .open(this.unifiedModal, {
                data: order.unifiedSourceTransactions,
                width: "90%",
                disableClose: true
            })
            .afterClosed()
            .subscribe(
        );
    }

    async generarPDF(data: any) {
        if (this.isGeneratingPDF && this.currentProcessingId === data._id) return;

        this.isGeneratingPDF = true;
        this.currentProcessingId = data._id;

        try {
            const range = await this.fetchAllDocumentRange(data);
            const vehicle = await this.fetchAllVehicle(data);
            const compRef = createComponent(GuiaRemisionComponent, {
                environmentInjector: this.injector
            });

            // compRef.instance.guiaData = data;
            compRef.instance.guiaData = {
                ...data,                   
                range,   
                vehicle              
            };

            const el = document.createElement('div');
            document.body.appendChild(el);
            el.appendChild(compRef.location.nativeElement);

            compRef.changeDetectorRef.detectChanges();

            await compRef.instance.verPDF();

            setTimeout(() => {
                compRef.destroy();
                el.remove();
            }, 3000);

        } catch (err) {
            this.snackBar.open(err.error.message || "Error al generar PDF","Cerrar",{ duration: 5000});
        } finally {
            this.isGeneratingPDF = false;
            this.currentProcessingId = null;
        }
    }

    private async fetchAllDocumentRange(element: any): Promise<any[]> {
        return new Promise((resolve, reject) => {
            this.documentRangeService.findToComboBox(element?.type?.code).subscribe({
                next: (res) => {
                    resolve(res.data); 
                },
                error: (err) => {
                    this.snackBar.open(err.error.message || "Error al obtener rango de documentos.","Cerrar",{ duration: 5000});
                    reject(err); 
                },
            });
        });
    }

    private async fetchAllVehicle(element: any): Promise<any[]> {
        return new Promise((resolve, reject) => {
            this.tripService.findToComboBox(element?.trip?.id).subscribe({
                next: (res) => {
                    resolve(res.data); 
                },
                error: (err) => {
                    this.snackBar.open(err.error.message || "Error al obtener viajes","Cerrar",{ duration: 5000});
                    reject(err); 
                },
            });
        });
    }




}
